import { Box, Button, Text, Wrap, WrapItem } from '@chakra-ui/react';
import * as React from 'react';

import aiAskSourceStyles from '../../AIAskSources.module.css';
import type { FilteredListAssistantMessage } from '../../types';
import type { AiAskIndexData } from '../../utils/aiAskHelpers';
import {
  entityTypeDisplayLabel,
} from '../../utils/filteredList';
import { FormattedText } from '../shared/FormattedText';

export const FilteredListAnswer: React.FC<{
  message: FilteredListAssistantMessage;
  indexData?: AiAskIndexData;
  onViewResults: () => void;
  isLoading: boolean;
}> = ({ message, indexData, onViewResults, isLoading }) => {
  const entityLabel = entityTypeDisplayLabel(message.entityType, indexData);
  const filterEntries = Object.entries(message.filters);
  const answerText = String(message.answer ?? '').trim();
  const hasToken = Boolean(message.queryToken);

  return (
    <Box>
      {answerText ? (
        <Text className={aiAskSourceStyles.askText} mb={3} as="div">
          <FormattedText text={answerText} />
        </Text>
      ) : null}

      {message.count != null && Number.isFinite(message.count) ? (
        <Box mb={2}>
          <Text
            as="span"
            fontWeight="700"
            fontSize="lg"
            color="gray.800"
            mr={2}
          >
            {message.count.toLocaleString()}
          </Text>
          <Text as="span" fontSize="sm" color="gray.600">
            {entityLabel}
          </Text>
        </Box>
      ) : null}

      {filterEntries.length > 0 ? (
        <Wrap spacing={2} mb={3}>
          {filterEntries.map(([filterKey, filterValue]) => (
            <WrapItem key={filterKey}>
              <Box
                px={2}
                py={1}
                borderRadius="md"
                bg="white"
                borderWidth="1px"
                borderColor="gray.200"
                fontSize="xs"
                color="gray.700"
              >
                {filterKey}: {filterValue}
              </Box>
            </WrapItem>
          ))}
        </Wrap>
      ) : null}

      <Button
        size="sm"
        colorScheme="blue"
        variant="solid"
        onClick={onViewResults}
        isLoading={isLoading}
        isDisabled={!hasToken}
        title={hasToken ? 'View Results' : 'View Results unavailable'}
      >
        View Results
      </Button>

      {message.viewResultsError ? (
        <Text fontSize="sm" color="red.500" mt={2}>
          {message.viewResultsError}
        </Text>
      ) : null}
    </Box>
  );
};
